import api from '../api';

const BASE_URL = '/api/v2/calendar-events';

const CalendarEventsApi = {
	getAllCalendarEvents: ({ page, perPage, date, category, title }) =>
		api.get(
			`${BASE_URL}?${page ? `page=${page}` : ''}${perPage ? `&per_page=${perPage}` : ''}${
				date ? `&date=${date}` : ''
			}${category ? `&category=${category}` : ''}${title ? `&title=${title}` : ''}`
		),
	getCalendarEvent: (CalendarEventId) => api.get(`${BASE_URL}/${CalendarEventId}`),
	createCalendarEvent: (payload) => api.post(BASE_URL, payload),
	updateCalendarEvent: (CalendarEventId, payload) =>
		api.patch(`${BASE_URL}/${CalendarEventId}`, payload),
	deleteCalendarEvent: (CalendarEventId) => api.delete(`${BASE_URL}/${CalendarEventId}`),
};

export default CalendarEventsApi;
